import { AppContext } from './AppContext';
import { useContext } from 'react';

export const useWorkMode = () => {
  const context = useContext(AppContext);

  return context.workMode;
};
